import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @Products
 * @Products
 * @products
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"description","type":"text","placeholder":"Description","label":"Description","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Description","derivedValue":"description=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"description","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"description","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"category","type":"relateAutoComplete","placeholder":"Category","label":"Category","width":"150px","addFormOrder":8,"editFormOrder":8,"header":"Category","derivedValue":"category=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"category","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1017,"searchField":"categoryName","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"Category","searchApi":"categories","isMultiple":false,"textAlign":"Center","show":true,"field":"category","showOrHideFields":[],"fieldName":"category","mobile":true,"displayInSettings":true},{"name":"inventoryType","type":"dropDown","placeholder":"Inventory Type","label":"Inventory Type","width":"130px","addFormOrder":9,"editFormOrder":9,"header":"Inventory Type","derivedValue":"inventoryType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"inventoryType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":1017,"options":[{"label":"Medicine","value":"Medicine","color":"primary"},{"label":"Non-Medicine","value":"Non-Medicine","color":"primary"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":false,"field":"inventoryType","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"volume","type":"text","placeholder":"Volume","label":"Volume","width":"130px","addFormOrder":10,"editFormOrder":10,"header":"Volume","derivedValue":"volume=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"volume","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":false,"field":"volume","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"batteryExists","type":"radio","placeholder":"Battery Exists","label":"Battery Exists","width":"120px","addFormOrder":11,"editFormOrder":11,"header":"Battery Exists","derivedValue":"batteryExists=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"batteryExists","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Yes","value":"Yes"},{"label":"No","value":"No"}],"fieldType":"radio","textAlign":"Center","show":false,"field":"batteryExists","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"categoryDrop","type":"dropDown","placeholder":"CategoryDrop","label":"CategoryDrop","width":"130px","addFormOrder":12,"editFormOrder":12,"header":"CategoryDrop","derivedValue":"categoryDrop=categoryDrop=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"categoryDrop","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Medicine","value":"Medicine","color":"primary","dependentField":["inventoryType","volume"]},{"label":"Non-Medicine","value":"Non-Medicine","color":"primary","dependentField":["batteryExists"]}],"fieldType":"dropDown","dependent":[{"Medicine":["inventoryType","volume"]},{"Non-Medicine":["batteryExists"]}],"textAlign":"Center","show":false,"field":"categoryDrop","showOrHideFields":["batteryExists","inventoryType","volume"],"label0":"Medicine","dependentField0":["inventoryType","volume"],"color0":"primary","value0":"Medicine","label1":"Non-Medicine","dependentField1":["batteryExists"],"color1":"primary","value1":"Non-Medicine","fieldName":"categoryDrop","mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"description","type":"text","placeholder":"Description","label":"Description","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"description=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"description","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"category","type":"relateAutoComplete","placeholder":"Category","label":"Category","width":"150px","addFormOrder":8,"editFormOrder":8,"derivedValue":"category=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"category","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1017,"searchField":"categoryName","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"Category","searchApi":"categories","isMultiple":false,"show":true,"showOrHideFields":[],"fieldName":"category","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"inventoryType","type":"dropDown","placeholder":"Inventory Type","label":"Inventory Type","width":"130px","addFormOrder":9,"editFormOrder":9,"derivedValue":"inventoryType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"inventoryType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":1017,"options":[{"label":"Medicine","value":"Medicine","color":"primary"},{"label":"Non-Medicine","value":"Non-Medicine","color":"primary"}],"fieldType":"dropDown","dependent":[],"show":false,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"volume","type":"text","placeholder":"Volume","label":"Volume","width":"130px","addFormOrder":10,"editFormOrder":10,"derivedValue":"volume=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"volume","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":false,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"batteryExists","type":"radio","placeholder":"Battery Exists","label":"Battery Exists","width":"120px","addFormOrder":11,"editFormOrder":11,"derivedValue":"batteryExists=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"batteryExists","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Yes","value":"Yes"},{"label":"No","value":"No"}],"fieldType":"radio","show":false,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"categoryDrop","type":"dropDown","placeholder":"CategoryDrop","label":"CategoryDrop","width":"130px","addFormOrder":12,"editFormOrder":12,"derivedValue":"categoryDrop=categoryDrop=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"categoryDrop","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Medicine","value":"Medicine","color":"primary","dependentField":["inventoryType","volume"]},{"label":"Non-Medicine","value":"Non-Medicine","color":"primary","dependentField":["batteryExists"]}],"fieldType":"dropDown","dependent":[{"Medicine":["inventoryType","volume"]},{"Non-Medicine":["batteryExists"]}],"show":true,"showOrHideFields":["batteryExists","inventoryType","volume"],"label0":"Medicine","dependentField0":["inventoryType","volume"],"color0":"primary","value0":"Medicine","label1":"Non-Medicine","dependentField1":["batteryExists"],"color1":"primary","value1":"Non-Medicine","fieldName":"categoryDrop","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const Products = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const [inventryType, setInventryType] = useState(undefined);
  const [paramsObj, setParamsObj] = useState();
  const query = new URLSearchParams(location.search);
  const companyId = query.get('comapnyId');
  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Product Directory");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
    getInventryType();
    if (params.id && params.id.includes('-')) {
      let arr = params.id.split('-');
      setParamsObj({
        facilityName: arr[0],
        storageUnitId: arr[1],
      })
    } else if (params && window.location.href.includes("redirect")) {
      const storedLoginBody = JSON.parse(localStorage.getItem("loginCredentials"));
      if (storedLoginBody && storedLoginBody._id && storedLoginBody.role === 'Admin') {
        setParamsObj({ companyId: storedLoginBody._id });
      } else if (storedLoginBody && storedLoginBody._id && storedLoginBody.role === 'Staff') {
        setParamsObj({ companyId: storedLoginBody.company_Id });
      }
    } else {
      setParamsObj({})
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getInventryType = () => {
    return fetchMethodRequest("GET", apiCalls.Settings
    ).then(async (response) => {
      if (response && response.inventoryTypes) {
        setInventryType(response.inventoryTypes)
      }
    });
  }

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      /**not using For Now */
      // {
      //   textAlign: "center",
      //   width: 47,
      //   field: "Check Box",
      //   label: "Check Box",
      //   fieldType: "multiple",
      //   header: "",
      //   selectionMode: "multiple",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      // },
      {
        textAlign: "Center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "productName",
        type: "text",
        placeholder: "ProductName",
        label: "ProductName",
        width: "260px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "ProductName",
        derivedValue: "productName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "productName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "productName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "140px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Description",
        derivedValue: "description=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "description",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },

      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "80px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Volume",
        derivedValue: "volume=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "volume",
        showOrHideFields: [],
        fieldType: 'isCountZero',
        mobile: true,
        displayInSettings: true,
      },

      {
        name: "companyName",
        type: "Text",
        capitalizeTableText: true,
        placeholder: "Company Name",
        label: "Company Name",
        width: 120,
        header: "Company Name",
        id: "companyName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: false,
        sortable: true,
        textAlign: 'left',
        field: "companyName",
        mobile: true,
        displayInSettings: true,
      },

      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "productName",
        type: "text",
        placeholder: "Product Name",
        label: "ProductName",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "ProductName",
        derivedValue: "productName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "productName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "productName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "description=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "category",
        type: "relateAutoComplete",
        placeholder: "Category",
        label: "Category",
        width: "150px",
        addFormOrder: 8,
        editFormOrder: 8,
        derivedValue: "category=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "category",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: 1017,
        searchField: "categoryName",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "Category",
        searchApi: "categories",
        isMultiple: false,
        show: true,
        showOrHideFields: [],
        fieldName: "category",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "inventoryType",
        type: "dropDown",
        placeholder: "Inventory Type",
        label: "Inventory Type",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        derivedValue: "inventoryType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "inventoryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: 1017,
        options: [
          { label: "Medicine", value: "Medicine", color: "primary" },
          { label: "Non-Medicine", value: "Non-Medicine", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: false,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        derivedValue: "volume=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "batteryExists",
        type: "radio",
        placeholder: "Battery Exists",
        label: "Battery Exists",
        width: "120px",
        addFormOrder: 11,
        editFormOrder: 11,
        derivedValue: "batteryExists=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "batteryExists",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          { label: "Yes", value: "Yes" },
          { label: "No", value: "No" },
        ],
        fieldType: "radio",
        show: false,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "categoryType",
        type: "dropDown",
        placeholder: "Category Type",
        label: "Category Type",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        derivedValue: "categoryType=categoryType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "categoryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          {
            label: "Medicine",
            value: "Medicine",
            color: "primary",
            Field: ["inventoryType", "volume"],
          },
          {
            label: "Non-Medicine",
            value: "Non-Medicine",
            color: "primary",
            dependentField: ["batteryExists"],
          },
        ],
        fieldType: "dropDown",
        dependent: [
          { Medicine: ["inventoryType", "volume"] },
          { "Non-Medicine": ["batteryExists"] },
        ],
        show: true,
        showOrHideFields: ["batteryExists", "inventoryType", "volume"],
        label0: "Medicine",
        dependentField0: ["inventoryType", "volume"],
        color0: "primary",
        value0: "Medicine",
        label1: "Non-Medicine",
        dependentField1: ["batteryExists"],
        color1: "primary",
        value1: "Non-Medicine",
        fieldName: "categoryDrop",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        disabled: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        disabled: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Description",
        derivedValue: "description=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "description",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "category",
        type: "relateAutoComplete",
        placeholder: "Category",
        label: "Category",
        width: "150px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Category",
        derivedValue: "category=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "category",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: 1017,
        searchField: "categoryName",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "Category",
        searchApi: "categories",
        isMultiple: false,
        textAlign: "Center",
        show: true,
        field: "category",
        showOrHideFields: [],
        fieldName: "category",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "inventoryType",
        type: "dropDown",
        placeholder: "Inventory Type",
        label: "Inventory Type",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "Inventory Type",
        derivedValue: "inventoryType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "inventoryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: 1017,
        options: [
          { label: "Medicine", value: "Medicine", color: "primary" },
          { label: "Non-Medicine", value: "Non-Medicine", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "Center",
        show: false,
        field: "inventoryType",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Volume",
        derivedValue: "volume=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "volume",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "batteryExists",
        type: "radio",
        placeholder: "Battery Exists",
        label: "Battery Exists",
        width: "120px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Battery Exists",
        derivedValue: "batteryExists=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "batteryExists",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          { label: "Yes", value: "Yes" },
          { label: "No", value: "No" },
        ],
        fieldType: "radio",
        textAlign: "Center",
        show: false,
        field: "batteryExists",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "categoryDrop",
        type: "dropDown",
        placeholder: "CategoryDrop",
        label: "CategoryDrop",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "CategoryDrop",
        derivedValue: "categoryDrop=categoryDrop=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "categoryDrop",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          {
            label: "Medicine",
            value: "Medicine",
            color: "primary",
            dependentField: ["inventoryType", "volume"],
          },
          {
            label: "Non-Medicine",
            value: "Non-Medicine",
            color: "primary",
            dependentField: ["batteryExists"],
          },
        ],
        fieldType: "dropDown",
        dependent: [
          { Medicine: ["inventoryType", "volume"] },
          { "Non-Medicine": ["batteryExists"] },
        ],
        textAlign: "Center",
        show: false,
        field: "categoryDrop",
        showOrHideFields: ["batteryExists", "inventoryType", "volume"],
        label0: "Medicine",
        dependentField0: ["inventoryType", "volume"],
        color0: "primary",
        value0: "Medicine",
        label1: "Non-Medicine",
        dependentField1: ["batteryExists"],
        color1: "primary",
        value1: "Non-Medicine",
        fieldName: "categoryDrop",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        header: "Updated By",
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: true,
        field: "updatedByName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "updated",
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  // submit1 = item => {
  //   let x = productsFields
  //   let objproducts = {}

  //   objproducts["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objproducts[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objproducts,
  //     newFormFields: formFields
  //   });
  // }

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };

  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    // this.setState({
    //   isLoading: true
    // });
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["products"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
          // this.setState({
          //   isLoading: false
          // });
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {paramsObj &&
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          editRequired={false
            // rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={true
            // rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          addRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          // globalSearch={'Display Name/Email'}
          // type='Products'
          // apiUrl={apiCalls.Products}
          // exportRequried={true}
          printRequried={false}
          actionsTypes={false}
          refresh={true}
          getPagination={true}
          // [
          // {
          //   name: "Delete",
          //   options: [
          //     {
          //       label: "Delete",
          //       value: "Delete",
          //       show:
          //         rolePermission && rolePermission == "Edit" ? true : false,
          //       multiple: true,
          //     },
          //   ],
          // },

          // {
          //   'name': 'Block',
          //   "options": [
          //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'ResetPassword',
          //   "options": [
          //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'Submit',
          //   'action': this.submit,
          //   "options": [
          //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //   ]
          // },
          // {
          //   name: "newModel",
          //   action: this.submit1,
          //   options: [
          //     { label: "newModel", value: "newModel", show: true, multiple: false }
          //   ]
          // }
          // ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          selectionMode={true}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath["products"]}
          globalSearch={"Product Name / Description"}
          headerName="Product Directory"
          modalHeaderName='Product Directory'
          type="Products"
          routeTo={apiCalls["products"]}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["products"].toLowerCase()}
          apiUrl={apiCalls["products"]}
          selectedId={params.id}
          params={paramsObj}
          companyId={companyId}
        // hasQueryInCall={true}

        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          modalHeaderName='Product Directory'
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="products"
          apiUrl={apiCalls["products"]}
        />
      ) : null}
    </span>
  );
};

export default Products;
